import { uniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/vanilla';
import { default as InfiniteScrollTableUniDriver } from '../components/InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { InfiniteScrollCollectionListUniDriver } from '../components/InfiniteScrollCollectionList/InfiniteScrollCollectionList.uni.driver';
import PickerStandaloneUniDriver from '../components/PickerStandalone/PickerStandalone.uni.driver';
import { default as PickerModalUniDriver } from '../components/PickerModal/PickerModal.uni.driver';
import { CollectionViewsDropdownUniDriver } from '../components/CollectionViewsDropdown/CollectionViewsDropdown.uni.driver';
import { CollectionSaveViewModalUniDriver } from '../components/CollectionViewsDropdown/modals/SaveView/CollectionSaveViewModal.uni.driver';
import { CardsGridUniDriver } from '../components/Grid/CardsGrid.uni.driver';
import { TableGridSwitchUniDriver } from '../components/TableGridSwitch/TableGridSwitch.uni.driver';
import GridFoldersUniDriver from '../components/Grid/GridFolders.uni.driver';
import TableFoldersUniDriver from '../components/TableFolders/TableFolders.uni.driver';
import TableGridSwitchFoldersUniDriver from '../components/TableGridSwitchFolders/TableGridSwitchFolders.uni.driver';
import CustomFieldsWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsWidget.uni.driver';
import { NestedTableUniDriver } from '../components/NestedTable/NestedTable.uni.driver';
import CustomFieldsViewWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsViewWidget.uni.driver';
import TagsWidgetUniDriver from '../components/TagsWidget/TagsWidget.uni.driver';
import EntityPageUniDriver from '../components/EntityPage/EntityPage.uni.driver';
import CollectionPageUniDriver from '../components/CollectionPageNew/CollectionPage.uni.driver';
import SkeletonCardUniDriver from '../components/SkeletonCard/SkeletonCard.uni.driver';
import ErrorCardUniDriver from '../components/ErrorCard/ErrorCard.uni.driver';
import PageErrorStateUniDriver from '../components/PageErrorState/PageErrorState.uni.driver';
import CardContainerUniDriver from '../components/CardContainer/CardContainer.uni.driver';

export const InfiniteScrollTableTestkit = uniTestkitFactoryCreator(
  InfiniteScrollTableUniDriver,
);

export const CardsGridTestkit = uniTestkitFactoryCreator(CardsGridUniDriver);

export const TableGridSwitchTestkit = uniTestkitFactoryCreator(
  TableGridSwitchUniDriver,
);

export const EntityPageTestkit = uniTestkitFactoryCreator(EntityPageUniDriver);

export const CollectionPageTestkit = uniTestkitFactoryCreator(
  CollectionPageUniDriver,
);

export const CardContainerTestkit = uniTestkitFactoryCreator(
  CardContainerUniDriver,
);

export const CustomFieldsWidgetTestkit = uniTestkitFactoryCreator(
  CustomFieldsWidgetUniDriver,
);

export const CustomFieldsViewWidgetTestkit = uniTestkitFactoryCreator(
  CustomFieldsViewWidgetUniDriver,
);

export const TagsWidgetTestkit = uniTestkitFactoryCreator(TagsWidgetUniDriver);

export const GridFoldersTestkit =
  uniTestkitFactoryCreator(GridFoldersUniDriver);
export const TableFoldersTestkit = uniTestkitFactoryCreator(
  TableFoldersUniDriver,
);
export const NestedTableTestkit =
  uniTestkitFactoryCreator(NestedTableUniDriver);

export const TableGridSwitchFoldersTestkit = uniTestkitFactoryCreator(
  TableGridSwitchFoldersUniDriver,
);

export const InfiniteScrollCollectionListTestkit = uniTestkitFactoryCreator(
  InfiniteScrollCollectionListUniDriver,
);

export const PickerStandaloneTestkit = uniTestkitFactoryCreator(
  PickerStandaloneUniDriver,
);

export const PickerModalTestkit =
  uniTestkitFactoryCreator(PickerModalUniDriver);

export const ViewsStandaloneTestkit = uniTestkitFactoryCreator(
  CollectionViewsDropdownUniDriver,
);

export const ViewsStandaloneSaveModalTestkit = uniTestkitFactoryCreator(
  CollectionSaveViewModalUniDriver,
);

export const SkeletonCardTestkit = uniTestkitFactoryCreator(
  SkeletonCardUniDriver,
);
export const ErrorCardTestkit = uniTestkitFactoryCreator(ErrorCardUniDriver);

export const PageErrorStateTestkit = uniTestkitFactoryCreator(
  PageErrorStateUniDriver,
);
